import { render, staticRenderFns } from "./CurvesManagement.vue?vue&type=template&id=79b10784&scoped=true"
import script from "./CurvesManagement.vue?vue&type=script&lang=ts"
export * from "./CurvesManagement.vue?vue&type=script&lang=ts"
import style0 from "./CurvesManagement.vue?vue&type=style&index=0&id=79b10784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b10784",
  null
  
)

export default component.exports